/**
 * i18n utilities for LUKHAS iD
 *
 * Provides locale detection, storage, and utility functions
 */

export type Locale = 'en' | 'es'

export const supportedLocales: Locale[] = ['en', 'es']
export const defaultLocale: Locale = 'en'

const LOCALE_STORAGE_KEY = 'lukhas_id_locale'

/**
 * Get stored locale from localStorage
 */
export function getStoredLocale(): Locale | null {
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY)
    if (stored && supportedLocales.includes(stored as Locale)) {
      return stored as Locale
    }
  } catch {
    // Ignore storage errors
  }
  return null
}

/**
 * Store locale preference
 */
export function setStoredLocale(locale: Locale): void {
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale)
  } catch {
    // Ignore storage errors
  }
}

/**
 * Detect browser locale
 */
export function detectBrowserLocale(): Locale {
  try {
    const browserLang = navigator.language.split('-')[0].toLowerCase()
    if (supportedLocales.includes(browserLang as Locale)) {
      return browserLang as Locale
    }
  } catch {
    // Ignore detection errors
  }
  return defaultLocale
}

/**
 * Get current locale (stored > browser > default)
 */
export function getLocale(): Locale {
  return getStoredLocale() || detectBrowserLocale() || defaultLocale
}
